<template>
	<svg
		width="17px"
		height="15px"
		viewBox="0 0 17 15"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
	>
		<title>bell-slash-solid copy</title>
		<g
			id="Symbols"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Drawer-/-Mentions"
				transform="translate(-268.000000, -538.000000)"
				:fill="fill"
				fill-rule="nonzero"
			>
				<g
					id="bell-slash-solid-copy"
					transform="translate(268.000000, 538.000000)"
				>
					<path
						d="M16.8358669,12.1682014 L14.4287664,10.3075105 C14.4338133,10.2708545 14.4500165,10.2368547 14.4500165,10.1996675 C14.4513446,9.99912192 14.3806882,9.79406076 14.2213127,9.62299938 C13.7081238,9.0715655 12.7478868,8.24202407 12.7478868,5.52469814 C12.7478868,3.46080543 11.3007578,1.80862876 9.3494711,1.40328767 L9.3494711,0.849994425 C9.3494711,0.380638128 8.96909505,0 8.5,0 C8.03090495,0 7.6505289,0.380638128 7.6505289,0.849994425 L7.6505289,1.40355329 C6.5792603,1.62614558 5.66736715,2.22884476 5.05828734,3.06555802 L1.20777667,0.0895150379 C1.0223699,-0.0544527678 0.755150412,-0.0212498606 0.611181263,0.164155173 L0.0894923172,0.835385146 C-0.0544768318,1.02052456 -0.0212736148,1.28747593 0.164133149,1.43170936 L15.7922233,13.5103958 C15.9776301,13.6546292 16.244584,13.6211607 16.3888187,13.4357556 L16.9105077,12.7645257 C17.0544768,12.5793862 17.0212736,12.3124349 16.8358669,12.1682014 Z M4.17640989,6.68148743 C3.94770613,8.48666309 3.20926659,9.16054929 2.77868727,9.62326501 C2.61931183,9.79459201 2.54865538,9.99938754 2.54996515,10.1999331 C2.55290539,10.6355552 2.89476572,11.0499275 3.40264212,11.0499275 L9.82865993,11.0499275 L4.17640989,6.68148743 Z M8.5,13.5999108 C9.4381901,13.5999108 10.1992078,12.8389002 10.1992078,11.8999219 L6.80079217,11.8999219 C6.80079217,12.8389002 7.5618099,13.5999108 8.5,13.5999108 Z"
						id="Shape"
					/>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'GroupMute',
	props: {
		selected: {
			type: Boolean,
			default: null,
		},
	},

	computed: {
		fill() {
			return this.selected ? '#fff' : '#9498A3'
		},
	},
}
</script>
